"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/map");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/filter");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCurrentUserImageResponse = exports.getCurrentUserImageEpic = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _Observable = require("rxjs/Observable");

var _operators = require("rxjs/operators");

var _auth = require("../../../auth");

var _observableErrorHandler = require("../../../redux/observableErrorHandler");

var _UserActions = require("../../models/UserActions");

var _requireAuthentication = require("../requireAuthentication");

var _userApi = require("../userApi");

var _userRegistry = require("../userRegistry");

var getCurrentUserImageEpic = function getCurrentUserImageEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(_UserActions.UserActions.getMyUserRequest).pipe((0, _filterInstanceProperty(_operators))((0, _requireAuthentication.requireAuthentication)(store)), (0, _operators.switchMap)(function (action) {
    var currentUser = (0, _auth.getUserAuth)();
    var userId = currentUser.profile && currentUser.profile.oid;

    if (window !== top) {
      return _Observable.Observable.of({
        type: _UserActions.UserActions.getMyImageResponse
      });
    }

    return ajax({
      method: 'POST',
      url: _userApi.getImagesApiUrl,
      body: [userId]
    }).pipe((0, _mapInstanceProperty(_operators))(function (payload) {
      return {
        type: _UserActions.UserActions.getMyImageResponse,
        payload: payload.response
      };
    }), (0, _operators.catchError)((0, _observableErrorHandler.errorHandler)(_UserActions.UserActions.getMyImageFailed, action)));
  }));
}; // FIXME: This appears to be broken and also unnecessary because we get the
//        user's profile image from MS Graph now.
//
//        Disabling this epic by default for now until it can be fully
//        deprecated or triaged. There was effectively no user impact at the
//        time of this comment.


exports.getCurrentUserImageEpic = getCurrentUserImageEpic;

if (process.env.APP_ENABLE_USER_IMAGE_API === 'false') {
  _userRegistry.userRegistry.addEpic('getCurrentUserImageEpic', getCurrentUserImageEpic);
}

var getCurrentUserImageResponse = function getCurrentUserImageResponse(state, action) {
  if (action.payload === undefined || action.payload.length !== 1) {
    return state;
  }

  var nextState = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    userImage: action.payload[0]
  });
  return nextState;
};

exports.getCurrentUserImageResponse = getCurrentUserImageResponse;

_userRegistry.userRegistry.add(_UserActions.UserActions.getMyImageResponse, getCurrentUserImageResponse);